import * as React from 'react';
import RoundedButton, {ButtonType} from '../../elements/RoundedButton';
import Localized from 'src/constants/AppStrings';
import Styles from 'src/components/Styles';
import Settings from '../../../Settings';
import {BuildTypeEnum} from '../../../constants/BuildTypeEnum';

type GiveCreditFooterProps = {
  onPress: () => void;
};

class GiveCreditFooter extends React.Component<GiveCreditFooterProps> {
  render() {
    return (
      <RoundedButton
        buttonType={ButtonType.normal}
        containerStyle={{alignSelf: 'flex-end', marginTop: Styles.Spacing.m3}}
        onPress={this.props.onPress}
        accessibilityLabel="Add Credit"
        text={Localized.Labels.start_purchasing}
        color={
          Settings.buildType === BuildTypeEnum.aramark
            ? Styles.Colors.Aramark.primary
            : Styles.Colors.PayNew.primary01
        }
      />
    );
  }
}

export default GiveCreditFooter;
